import React from 'react';
import { 
  ChevronRight, 
  Terminal, 
  FolderArchive, 
  Package, 
  Github, 
  Boxes 
} from 'lucide-react';


const DockerIcon = ({ size = 24, className = "" }) => (
  <svg className={className} viewBox="0 0 24 24" width={size} height={size} stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
  </svg>
);
export default function DeployHome({ setActiveTab, setRepoMode }) {
  return (
    <div className="vercel-deploy-container">
      <div style={{ textAlign: 'center', marginBottom: '2.5rem', marginTop: '1rem' }}>
        <div className="dashboard-empty-icon" style={{ opacity: 0.2, marginBottom: '1.5rem', display: 'flex', justifyContent: 'center', color: 'var(--primary)' }}>
          <DockerIcon size={64} />
        </div>
        <h1 className="dashboard-empty-title" style={{ fontSize: '1.8rem', marginBottom: '0.5rem', fontWeight: 800 }}>Ready to launch your next project?</h1>
        <p className="dashboard-empty-subtitle" style={{ fontSize: '1.05rem', opacity: 0.8, fontWeight: 500 }}>Transform your code into a live application in seconds. Select a deployment source below to get started.</p>
      </div>

      <div className="vercel-sections">
        {/* Main Section: Import */}
        <section className="vercel-section">
          <h2 className="section-label">Import Application</h2>
          <div className="vercel-card-main-grid">
            <div className="vercel-card-main" onClick={() => setActiveTab('hub')}>
              <div className="card-icon hub">
                <DockerIcon size={24} />
              </div>
              <div className="card-info">
                <h3>Import from Docker Hub</h3>
                <p>Search millions of images and deploy with one click.</p>
              </div>
              <div className="card-action">
                <button className="vercel-btn-sm">Import</button>
              </div>
            </div>

            <div className="vercel-card-main" onClick={() => { setActiveTab('repo'); setRepoMode && setRepoMode('connect'); }}>
              <div className="card-icon hub">
                <Github size={24} />
              </div>
              <div className="card-info">
                <h3>Import from GitHub / GitLab</h3>
                <p>Clone repository, run frontend build, and deploy static output.</p>
              </div>
              <div className="card-action">
                <button className="vercel-btn-sm">Import</button>
              </div>
            </div>
          </div>
        </section>

        {/* Secondary Section: Other methods */}
        <section className="vercel-section">
          <h2 className="section-label">Manual Deployment</h2>
          <div className="vercel-grid">
            <div className="vercel-card-sub" onClick={() => setActiveTab('compose')}>
              <div className="card-header">
                <Terminal size={20} />
                <h3>Docker Compose</h3>
              </div>
              <p>Launch an isolated workspace to build, upload, and run Docker Compose projects.</p>
              <div className="card-footer">
                <span>Open Workspace</span>
                <ChevronRight size={14} />
              </div>
            </div>

            <div className="vercel-card-sub" onClick={() => setActiveTab('zip')}>
              <div className="card-header">
                <FolderArchive size={20} />
                <h3>App ZIP</h3>
              </div>
              <p>Upload a project ZIP. Opens an AI workspace to install, run, and verify — same flow as GitHub/GitLab backend.</p>
              <div className="card-footer">
                <span>Deploy ZIP</span>
                <ChevronRight size={14} />
              </div>
            </div>

            <div className="vercel-card-sub" onClick={() => setActiveTab('docker')}>
              <div className="card-header">
                <Package size={20} />
                <h3>Docker Image</h3>
              </div>
              <p>Deploy using a local Docker image tarball.</p>
              <div className="card-footer">
                <span>Deploy Tar</span>
                <ChevronRight size={14} />
              </div>
            </div>

            <div className="vercel-card-sub" onClick={() => setActiveTab('template')}>
              <div className="card-header">
                <Boxes size={20} className="text-secondary" />
                <h3>Use Template</h3>
              </div>
              <p>Launch multi-container templates (Node + MongoDB, Node + MySQL, etc.) with pre-configured stacks.</p>
              <div className="card-footer">
                <span>Deploy Template Stack</span>
                <ChevronRight size={14} />
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
